import colors from 'src/app/theme/colors';
import googleReviewsCardBlack from '/public/store-products/google-reviews-card/google-reviews-card-black.png';
import googleReviewsCardWhite from '/public/store-products/google-reviews-card/google-reviews-card-white.png';
import googleReviewsCardBlackAndWhite from '/public/store-products/google-reviews-card/google-reviews-card-black-and-white.png';
import googleReviewsCardInterior from '/public/store-products/google-reviews-card/google-reviews-card-interior.png';
import googleReviewsMultipleCards from '/public/store-products/google-reviews-card/google-reviews-multiple-cards.jpg';
import googleReviewsStandBlack from '/public/store-products/google-review-stand/google-reviews-stand-black.png';
import googleReviewsStandWhite from '/public/store-products/google-review-stand/google-reviews-stand-white.png';
import googleReviewsStandInterior from '/public/store-products/google-review-stand/google-reviews-stand-interior.png';
import googleReviewsPlateBlack from '/public/store-products/google-review-plate/google-reviews-plate-black.png';
import googleReviewsPlateWhite from '/public/store-products/google-review-plate/google-reviews-plate-white.png';
import googleReviewsPlateOnTable from '/public/store-products/google-review-plate/google-reviews-plate-on-table.png';
import googleReviewsPlateOnDoors1 from '/public/store-products/google-review-plate/google-reviews-plate-on-doors-1.png';
import googleReviewsPlateOnDoors2 from '/public/store-products/google-review-plate/google-reviews-plate-on-doors-2.png';
import { ProductType } from '../types/ProductType';
import { defaultBenefits, defaultCustomBlocks } from './productDefaults';

const products: ProductType[] = [
  {
    slug: 'google-review-card',
    type: 'card',
    name: 'store.products.card.name',
    description: 'store.products.card.description',
    price: 19,
    heroVideo: {
      src: {
        base: '/store-products/google-reviews-card/hero-card-mobile.webm',
        md: '/store-products/google-reviews-card/hero-card-desktop.webm',
      },
      srcFallback: {
        base: '/store-products/google-reviews-card/hero-card-mobile.mp4',
        md: '/store-products/google-reviews-card/hero-card-desktop.mp4',
      },
    },
    variants: [
      {
        color: { value: 'white', label: 'store.products.card.colorWhite', hex: colors.white },
        images: [
          {
            id: '2',
            type: 'image',
            src: googleReviewsCardWhite,
            alt: 'Google Reviews Card NFC Tag and QR White',
          },
        ],
      },
      {
        color: { value: 'black', label: 'store.products.card.colorBlack', hex: colors.black },
        images: [
          {
            id: '1',
            type: 'image',
            src: googleReviewsCardBlack,
            alt: 'Google Reviews Card NFC Tag and QR Black',
          },
        ],
      },
    ],
    commonImages: [
      {
        id: '0',
        type: 'image',
        src: googleReviewsCardInterior,
        alt: 'Google Reviews Card NFC Tag and QR Interior',
      },
      {
        id: '3',
        type: 'image',
        src: googleReviewsCardBlackAndWhite,
        alt: 'Google Reviews Card NFC Tag Black and White',
      },
      {
        id: '4',
        type: 'image',
        src: googleReviewsMultipleCards,
        alt: 'Google Reviews Card NFC Tag and QR Multiple Cards',
      },
    ],
    benefits: defaultBenefits,
    techSpecs: {
      size: '105 mm x 149 mm',
      weight: '35 g',
      material: 'Waterproof matte PVC',
      chip: 'NXP NTAG213 (13.56 MHz HF)',
      compatibility: 'iOS 13+ & Android 5.0+',
    },
    customBlocks: defaultCustomBlocks,
    howItWorksDescription: 'store.products.card.howItWorksDescription',
  },
  {
    slug: 'google-review-stand',
    type: 'stand',
    name: 'store.products.stand.name',
    description: 'store.products.stand.description',
    price: 49,
    heroVideo: {
      src: {
        base: '/store-products/google-review-stand/hero-stand-mobile.webm',
        md: '/store-products/google-review-stand/hero-stand-desktop.webm',
      },
      srcFallback: {
        base: '/store-products/google-review-stand/hero-stand-mobile.mp4',
        md: '/store-products/google-review-stand/hero-stand-desktop.mp4',
      },
    },
    variants: [
      {
        color: { value: 'white', label: 'store.products.card.colorWhite', hex: colors.white },
        images: [
          {
            id: '2',
            type: 'image',
            src: googleReviewsStandWhite,
            alt: 'Google Reviews Stand NFC White',
          },
        ],
      },
      {
        color: { value: 'black', label: 'store.products.card.colorBlack', hex: colors.black },
        images: [
          {
            id: '5',
            type: 'image',
            src: googleReviewsStandBlack,
            alt: 'Google Reviews Stand NFC Black',
          },
        ],
      },
    ],
    commonImages: [
      {
        id: '7',
        type: 'image',
        src: googleReviewsStandInterior,
        alt: 'Google Reviews Stand Interior',
      },
    ],
    benefits: defaultBenefits,
    techSpecs: {
      size: '100 mm x 140 mm x 50 mm',
      weight: '150 g',
      material: 'Waterproof matte PVC',
      chip: 'NXP NTAG213 (13.56 MHz HF)',
      compatibility: 'iOS 13+ & Android 5.0+',
    },
    customBlocks: defaultCustomBlocks,
    howItWorksDescription: 'store.products.stand.howItWorksDescription',
  },
  {
    slug: 'google-review-plate',
    type: 'plate',
    name: 'store.products.plate.name',
    description: 'store.products.plate.description',
    price: 59,
    heroVideo: {
      src: {
        base: '/store-products/google-review-plate/hero-plate-mobile.webm',
        md: '/store-products/google-review-plate/hero-plate-desktop.webm',
      },
      srcFallback: {
        base: '/store-products/google-review-plate/hero-plate-mobile.mp4',
        md: '/store-products/google-review-plate/hero-plate-desktop.mp4',
      },
    },
    variants: [
      {
        color: { value: 'white', label: 'store.products.card.colorWhite', hex: colors.white },
        images: [
          {
            id: '12',
            type: 'image',
            src: googleReviewsPlateWhite,
            alt: 'Google Reviews Plate NFC Tag and QR White',
          },
        ],
      },
      {
        color: { value: 'black', label: 'store.products.card.colorBlack', hex: colors.black },
        images: [
          {
            id: '11',
            type: 'image',
            src: googleReviewsPlateBlack,
            alt: 'Google Reviews Plate NFC Tag and QR Black',
          },
        ],
      },
    ],
    commonImages: [
      {
        id: '13',
        type: 'image',
        src: googleReviewsPlateOnTable,
        alt: 'Google Reviews Plate on Table',
      },
      {
        id: '14',
        type: 'image',
        src: googleReviewsPlateOnDoors1,
        alt: 'Google Reviews Plate on Doors 1',
      },
      {
        id: '15',
        type: 'image',
        src: googleReviewsPlateOnDoors2,
        alt: 'Google Reviews Plate on Doors 2',
      },
    ],
    benefits: defaultBenefits,
    techSpecs: {
      size: '120 mm x 120 mm',
      weight: '45 g',
      material: 'Waterproof matte PVC',
      chip: 'NXP NTAG213 (13.56 MHz HF)',
      compatibility: 'iOS 13+ & Android 5.0+',
    },
    customBlocks: defaultCustomBlocks,
    howItWorksDescription: 'store.products.plate.howItWorksDescription',
  },
];

export default products;
